export default __webpack_public_path__ + "static/media/html.a44622e3.png";